import { Dropdown as AntdDropdown, type DropdownProps } from 'antd'
import './Dropdown.less'

export const Dropdown = (props: DropdownProps) => <AntdDropdown {...props} />

export default Dropdown
